import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function SchadenKIToggle() {
  const { t } = useTranslation();
  const useSchadenKI = SettingsStore(state => state.useSchadenKI);
  const setUseSchadenKI = SettingsStore(state => state.setUseSchadenKI);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="use-schaden-ki">{t("settings.useSchadenKI")}</Label>
        <Switch
          id="use-schaden-ki"
          checked={useSchadenKI}
          onCheckedChange={setUseSchadenKI}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}

